var Glide = window.Glide;
var AOS = window.AOS;
var hoverintent = window.hoverintent;

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

const BREAK_MD = 768;
const BREAK_LG = 992;
const BREAK_XL = 1132;

const setQueryStringParameter = (name, value) => {
  const params = new URLSearchParams(window.location.search);
  params.set(name, value);
  window.history.replaceState(
    {},
    "",
    decodeURIComponent(`${window.location.pathname}?${params}`)
  );
};

const getQueryStringParameter = (name) => {
  const params = new URLSearchParams(window.location.search);
  return params.get(name);
};

const clearCollectionRestoreParams = () => {
  const params = new URLSearchParams(window.location.search);
  params.delete("pagination__more");
  params.delete("selectedProductId");
  const qs = params.toString();
  window.history.replaceState(
    {},
    "",
    qs ? `${window.location.pathname}?${qs}` : window.location.pathname
  );
};

const saveCollectionRestoreState = (productCard) => {
  const container = document.querySelector("[data-pagination-container]");
  if (!container || !productCard) return;

  const productId = productCard.getAttribute("id");
  if (!productId) return;

  sessionStorage.setItem(
    "collectionRestore",
    JSON.stringify({
      path: window.location.pathname,
      paginationCount: container.children.length,
      productId: productId,
    })
  );
  setQueryStringParameter("selectedProductId", productId);
};

const scrollToSelectedProduct = () => {
  let productId = getQueryStringParameter("selectedProductId");

  if (!productId) {
    try {
      const saved = JSON.parse(sessionStorage.getItem("collectionRestore") || "{}");
      if (saved.path === window.location.pathname) {
        productId = saved.productId;
      }
    } catch (e) {}
  }

  if (!productId) return;

  const productEl = document.getElementById(productId);
  if (productEl) {
    requestAnimationFrame(function () {
      productEl.scrollIntoView({ block: "center" });
    });
  }
};

const shouldAutoRestorePagination = (container, targetCount) => {
  if (!container || !targetCount) return false;
  if (container.children.length >= targetCount) return false;

  const nav = performance.getEntriesByType("navigation")[0];
  if (nav && nav.type === "back_forward") {
    try {
      const saved = JSON.parse(sessionStorage.getItem("collectionRestore") || "{}");
      if (
        saved.path === window.location.pathname &&
        container.children.length >= saved.paginationCount
      ) {
        return false;
      }
    } catch (e) {}
  }

  return true;
};

const finishPaginationRestore = () => {
  scrollToSelectedProduct();
  clearCollectionRestoreParams();
};

window.scrollToSelectedProduct = scrollToSelectedProduct;

const fixIosControls = (carousel) => {
  var selector = carousel.selector;
  var glideArrows = document.querySelectorAll(selector + " .glide__arrow");

  glideArrows.forEach(function (glideArrow) {
    glideArrow.addEventListener("click", function (e) {
      e.preventDefault();
      carousel.go(this.dataset.glideDir);
    });
  });
};

const adaptiveHeight = (carousel) => {
  var selector = carousel.selector;

  const buildHeight = () => {
    setTimeout(() => {
      var activeSlide = document.querySelector(selector + " .glide__slide--active");
      var glideTrack = document.querySelector(selector + " .glide__track");
      if (!activeSlide || !glideTrack) return;
      var slideHeight = activeSlide.offsetHeight;
      var trackHeight = glideTrack.offsetHeight;
      if (slideHeight != trackHeight) {
        glideTrack.style.height = slideHeight + "px";
      }
    }, 250);
  };

  carousel.on("build.after", function () {
    buildHeight();
  });

  carousel.on("run.after", function () {
    buildHeight();
  });
};

document.addEventListener("DOMContentLoaded", function () {
  var body = document.body;
  var last_known_scroll_position = 0;
  var ticking = false;

  function doScrollOperations(scrollY, prevScrollY) {
    if (scrollY > 142) {
      body.classList.add("header__locked");

      if (scrollY < prevScrollY) {
        body.classList.add("skr__negative");
      } else {
        body.classList.remove("skr__negative");
      }
    } else {
      if (!body.classList.contains("is--menu")) {
        body.classList.remove("header__locked");
        body.classList.remove("skr__negative");
      }
    }
  }

  window.addEventListener("scroll", function () {
    var prevScroll = last_known_scroll_position;
    last_known_scroll_position = window.scrollY;

    if (!ticking) {
      window.requestAnimationFrame(function () {
        doScrollOperations(last_known_scroll_position, prevScroll);
        ticking = false;
      });
      ticking = true;
    }
  });

  if (document.querySelector("#cta-carousel")) {
    var ctaCarousel = new Glide("#cta-carousel", {
      type: "slider",
      perView: 3,
      rewind: false,
      startAt: 0,
      breakpoints: {
        1024: { perView: 3 },
        993: { perView: 2 },
        720: {
          perView: 1,
          peek: { before: 0, after: 0 },
        },
      },
    });
    ctaCarousel.mount();
  }

  var quoteGlide = document.querySelector("#quote-glide");
  if (quoteGlide) {
    var quoteSlider = new Glide("#quote-glide", {
      type: "carousel",
      perView: 1,
      startAt: 0,
      autoplay: parseInt(quoteGlide.dataset.count) > 1 ? 5000 : false,
      animationDuration: 800,
    });

    quoteSlider.on("move", function () {
      var indx = quoteSlider.index;
      var contentQuote = quoteGlide.closest(".content-quote");
      if (!contentQuote) return;
      var bgs = contentQuote.querySelectorAll(".quote-bg");
      bgs.forEach(function (bg, i) {
        if (i === indx) {
          bg.classList.remove("hidden");
        } else {
          bg.classList.add("hidden");
        }
      });
    });

    quoteSlider.mount();
  }

  document.querySelectorAll("[data-banner-carousel]").forEach(function (el) {
    var autoplaySeconds = parseInt(el.dataset.autoplay, 10) || 0;

    var initBannerCarousel = function () {
      if (el.dataset.glideMounted === "true") return;
      el.dataset.glideMounted = "true";

      var glideOptions = {
        type: "slider",
        perView: 1,
        animationDuration: 0,
        swipeThreshold: false,
        dragThreshold: false,
      };

      if (autoplaySeconds > 0) {
        glideOptions.autoplay = autoplaySeconds * 1000;
      }

      var bannerCarousel = new Glide("#" + el.id, glideOptions);

      adaptiveHeight(bannerCarousel);

      el.querySelectorAll(".glide__arrow").forEach(function (glideArrow) {
        glideArrow.addEventListener("click", function () {
          bannerCarousel.go(glideArrow.dataset.glideDir);
        });
      });

      el.querySelectorAll(".glide__bullet").forEach(function (glideButton) {
        glideButton.addEventListener("click", function () {
          bannerCarousel.go(glideButton.dataset.glideDir);
        });
      });

      bannerCarousel.mount();
    };

    if (el.dataset.priority === "high" || !("IntersectionObserver" in window)) {
      initBannerCarousel();
    } else {
      var bannerObserver = new IntersectionObserver(
        function (entries) {
          if (!entries[0].isIntersecting) return;
          initBannerCarousel();
          bannerObserver.disconnect();
        },
        { rootMargin: "200px 0px" }
      );
      bannerObserver.observe(el);
    }
  });

  // Footer nav toggle on mobile
  document.body.addEventListener("click", function (e) {
    var link = e.target.closest(".footer__nav-header > a");
    if (!link) return;
    if (window.innerWidth > 767) return;
    e.preventDefault();
    link.closest("li").classList.toggle("open");
  });

  // Hamburger menu
  var isAnimatingMenu = false;

  document.body.addEventListener("click", function (e) {
    if (!e.target.closest(".header__hamburger")) return;
    e.preventDefault();
    if (isAnimatingMenu) return;
    isAnimatingMenu = true;

    var hasMenu = body.classList.contains("is--menu");
    var firstStep = hasMenu ? "is--menu" : "hide--content";
    var secondStep = !hasMenu ? "is--menu" : "hide--content";

    body.classList.toggle(firstStep);

    setTimeout(function () {
      body.classList.toggle(secondStep);
      isAnimatingMenu = false;
    }, 200);
  });

  // Search focus
  document.body.addEventListener("focusin", function (e) {
    if (e.target.matches('.header input[type="text"]')) {
      body.classList.add("is--searching");
    }
  });

  // Toggle details
  document.body.addEventListener("click", function (e) {
    var toggle = e.target.closest(".toggle-details");
    if (!toggle) return;
    e.preventDefault();
    toggle.classList.toggle("toggle-details--is-closed");
    var parent = toggle.closest("[data-toggle-details]");
    if (parent) parent.classList.toggle("toggle-details-closed");
  });

  // Product card add to cart (legacy forms only — quick-add-to-cart handles its own submit)
  document.body.addEventListener("submit", function (e) {
    var form = e.target.closest(".product-card form:not(.product-card__quick-add-form)");
    if (!form) return;
    e.preventDefault();

    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var data = new URLSearchParams();
    data.append("id", idInput ? idInput.value : "");
    data.append("quantity", qtyInput ? qtyInput.value : "");

    var btn = form.querySelector("button[type=submit]");
    if (btn) {
      btn.setAttribute("disabled", "true");
      btn.classList.add("is-disabled");
      var btnInner = btn.querySelector(".btn-inner");
      if (btnInner) btnInner.textContent = "Added";
    }

    fetch(form.getAttribute("action"), {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: data.toString(),
    }).then(function () {
      var card = form.closest(".product-card");
      if (card) card.classList.add("product-card--is-added");
    });
  });

  // Mobile nav top-level click
  document.body.addEventListener("click", function (e) {
    var link = e.target.closest(".header_nav-top");
    if (!link) return;
    if (body.classList.contains("is--menu")) {
      if (
        link.closest(".header__nav-column--has-children") ||
        link.closest(".header__nav-has-mega")
      ) {
        e.preventDefault();
        var secondary = link.parentElement
          ? link.parentElement.querySelector(".header__nav-secondary")
          : null;
        if (!secondary) {
          secondary = link.nextElementSibling;
          if (!secondary || !secondary.classList.contains("header__nav-secondary"))
            secondary = null;
        }
        if (secondary) secondary.classList.add("mobile-active");
      }
    }
  });

  // Wrap btn text in span
  document.querySelectorAll("p > a.btn, .content-col .btn").forEach(function (elem) {
    if (!elem.querySelector(".btn-inner")) {
      var span = document.createElement("span");
      span.className = "btn-inner";
      span.innerHTML = elem.innerHTML;
      elem.innerHTML = "";
      elem.appendChild(span);
    }
  });

  // Secondary nav mobile click
  document.body.addEventListener("click", function (e) {
    var link = e.target.closest(".header__nav-secondary-link > a");
    if (!link) return;
    if (window.innerWidth < BREAK_LG) {
      var tertiary = link.parentElement
        ? link.parentElement.querySelector(".header__nav-tertiary")
        : null;
      if (!tertiary) {
        var sib = link.nextElementSibling;
        if (sib && sib.classList.contains("header__nav-tertiary")) tertiary = sib;
      }
      if (tertiary) {
        e.preventDefault();
        tertiary.classList.add("mobile-active");
      }
    }
  });

  // Secondary nav back button
  document.body.addEventListener("click", function (e) {
    var btn = e.target.closest(".header__nav-secondary-back");
    if (!btn) return;
    e.preventDefault();
    var active = btn.closest(".mobile-active");
    if (active) active.classList.remove("mobile-active");
  });

  // Accordion button
  document.body.addEventListener("click", function (e) {
    var btn = e.target.closest(".accordion-button");
    if (!btn) return;
    btn.classList.toggle("show");
    var item = btn.closest(".accordion-item");
    if (item) {
      var collapse = item.querySelector(".accordion-collapse");
      if (collapse) collapse.classList.toggle("collapse");
    }
  });

  // Hash click for accordion
  if (document.querySelector(".accordion-button")) {
    var hash = window.location.hash;
    if (hash) {
      var button = document.querySelector(hash);
      if (button) button.click();
    }
  }

  // Product success
  if (document.querySelector(".product--success")) {
    var hash2 = window.location.hash;
    if (hash2 && hash2.indexOf("success") > -1) {
      body.classList.add("added-to-cart");
    }
  }

  // Accordion tabs
  document.body.addEventListener("click", function (e) {
    var tab = e.target.closest(".accordion-tabs li");
    if (!tab) return;
    if (tab.classList.contains("active")) return;

    var parent = tab.closest(".accordion");
    var active = tab.textContent;

    tab.classList.add("active");
    var siblings = tab.parentElement.children;
    Array.prototype.forEach.call(siblings, function (sib) {
      if (sib !== tab) sib.classList.remove("active");
    });

    if (parent) {
      parent.querySelectorAll(".accordion-item").forEach(function (item) {
        if (item.dataset.accordionCategory == active) {
          item.classList.add("display");
        } else {
          item.classList.remove("display");
        }
      });
    }
  });

  // Build accordion tabs
  var accordion = document.querySelectorAll(".accordion");
  if (accordion.length > 0) {
    accordion.forEach(function (elem) {
      var categories = [];

      document.querySelectorAll("[data-accordion-category]").forEach(function (catElem) {
        var category = catElem.dataset.accordionCategory;
        if (category && categories.indexOf(category) < 0) {
          categories.push(category);
        }
      });

      if (categories.length > 1) {
        var tabs = document.createElement("ul");
        tabs.className = "accordion-tabs";

        categories.forEach(function (category) {
          var li = document.createElement("li");
          li.textContent = category;
          tabs.appendChild(li);
        });

        var inner = elem.querySelector(".accordion-inner");
        if (inner) inner.prepend(tabs);

        var firstTab = tabs.querySelector("li:first-child");
        if (firstTab) firstTab.click();
      }
    });
  }

  // Projects filter
  var filterContainer = document.querySelector("#projects-filter");
  if (filterContainer) {
    ["Type", "Expertise", "Region"].forEach(function (filterName) {
      var options = [];
      var filterNameLower = filterName.toLowerCase();

      document.querySelectorAll(".project-filterable").forEach(function (project) {
        var data = project.dataset[filterNameLower];
        if (!data) return;
        data.split(";").forEach(function (value) {
          var clean = value.trim();
          options.push(clean);
        });
      });

      var dropdown = document.createElement("select");
      dropdown.setAttribute("name", "filter-" + filterNameLower);
      dropdown.dataset.filter = filterNameLower;

      var defaultOpt = document.createElement("option");
      defaultOpt.value = "";
      defaultOpt.textContent = "Select " + filterName;
      dropdown.appendChild(defaultOpt);

      options = options.sort();
      options = Array.from(new Set(options));

      options.forEach(function (option) {
        var opt = document.createElement("option");
        opt.value = option;
        opt.textContent = option;
        dropdown.appendChild(opt);
      });

      filterContainer.appendChild(dropdown);
    });

    var resetBtn = document.createElement("button");
    resetBtn.style.display = "none";
    resetBtn.className = "project-reset btn btn--small btn--orange";
    resetBtn.innerHTML = '<span class="btn-inner">Reset</span>';
    filterContainer.appendChild(resetBtn);

    // Filter reset
    document.body.addEventListener("click", function (e) {
      if (!e.target.closest("#projects-filter .project-reset")) return;
      filterContainer.querySelectorAll("select").forEach(function (sel) {
        sel.value = "";
        sel.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });

    // Filter change
    document.body.addEventListener("change", function (e) {
      var sel = e.target.closest("#projects-filter select");
      if (!sel) return;

      var value = sel.value;
      var count = 0;
      var resetEl = document.querySelector(".project-reset");

      if (value) {
        if (resetEl) resetEl.style.display = "";
      } else {
        var anything = false;
        filterContainer.querySelectorAll("select").forEach(function (s) {
          if (s.value) anything = true;
        });
        if (!anything && resetEl) resetEl.style.display = "none";
      }

      document.querySelectorAll(".project-filterable").forEach(function (project) {
        var matches = true;

        ["Type", "Expertise", "Region"].forEach(function (fn) {
          var fnLower = fn.toLowerCase();
          var fSel = document.querySelector("select[name=filter-" + fnLower + "]");
          var filterValue = fSel ? fSel.value : "";

          if (filterValue && (project.dataset[fnLower] || "").indexOf(filterValue) === -1) {
            matches = false;
          }
        });

        if (matches) {
          count++;
          project.classList.remove("hidden");
        } else {
          project.classList.add("hidden");
        }
      });

      var emptyEl = document.querySelector("#projects-empty");
      if (emptyEl) {
        emptyEl.style.display = count < 1 ? "" : "none";
      }
    });
  }

  // Locations carousel — mobile/tablet only; deferred until visible (Lighthouse)
  document.querySelectorAll("[data-location-carousel]").forEach(function (el) {
    var glideInstance = null;
    var desktopMQ = window.matchMedia("(min-width: 1025px)");

    var clearGlideInlineStyles = function () {
      var slides = el.querySelector(".glide__slides");
      if (slides) slides.removeAttribute("style");
    };

    var destroyCarousel = function () {
      if (!glideInstance) return;
      glideInstance.destroy();
      glideInstance = null;
      el.dataset.glideMounted = "false";
      clearGlideInlineStyles();
    };

    var mountCarousel = function () {
      if (desktopMQ.matches) {
        destroyCarousel();
        return;
      }
      if (el.dataset.glideMounted === "true") return;

      el.dataset.glideMounted = "true";

      glideInstance = new Glide("#" + el.id, {
        type: "slider",
        perView: 4,
        rewind: false,
        startAt: 0,
        breakpoints: {
          1024: {
            perView: 2,
            peek: { before: 0, after: 50 },
          },
          540: {
            perView: 1,
            peek: { before: 0, after: 50 },
          },
        },
      });
      glideInstance.mount();
    };

    var onBreakpointChange = function () {
      if (desktopMQ.matches) {
        destroyCarousel();
      } else {
        mountCarousel();
      }
    };

    desktopMQ.addEventListener("change", onBreakpointChange);

    if ("IntersectionObserver" in window) {
      var locationObserver = new IntersectionObserver(
        function (entries) {
          if (!entries[0].isIntersecting) return;
          mountCarousel();
          locationObserver.disconnect();
        },
        { rootMargin: "200px 0px" }
      );
      locationObserver.observe(el);
    } else {
      mountCarousel();
    }
  });

  // Timeline carousel
  if (document.querySelector("#timeline-carousel")) {
    var timeline = new Glide("#timeline-carousel", {
      type: "carousel",
      perView: 1,
      rewind: false,
      animationDuration: 0,
      startAt: 0,
    });
    adaptiveHeight(timeline);
    fixIosControls(timeline);
    timeline.mount();
  }

  // Product carousel
  if (document.querySelector("#product-carousel")) {
    new Glide("#product-carousel", {
      type: "slider",
      perView: 1,
      rewind: false,
      startAt: 0,
    }).mount();
  }

  // Featured collection carousels
  document.querySelectorAll(".featured-collection-carousel").forEach(function (elem) {
    new Glide(elem, {
      type: "slider",
      perView: 4,
      rewind: false,
      startAt: 0,
      breakpoints: {
        1024: {
          perView: 2,
          peek: { before: 0, after: 50 },
        },
        540: {
          perView: 1,
          peek: { before: 0, after: 50 },
        },
      },
    }).mount();
  });

  // Slideshow
  if (document.querySelector("#slideshow")) {
    new Glide("#slideshow", {
      type: "carousel",
      perView: 1,
      animationDuration: 0,
      startAt: 0,
    }).mount();
  }

  // Content carousel
  if (document.querySelector("#content-carousel")) {
    var contentCarousel = new Glide("#content-carousel", {
      type: "carousel",
      perView: 1,
      animationDuration: 0,
      startAt: 0,
    });
    adaptiveHeight(contentCarousel);
    contentCarousel.mount();
  }

  // People filter
  if (document.querySelector("#people-filter")) {
    var filters = [];
    var regions = [];

    document.querySelectorAll("[data-person]").forEach(function (person) {
      var filterExploded = (person.dataset.filter || "").split(";");
      var regionExploded = (person.dataset.region || "").split(";");

      filterExploded.forEach(function (filter) {
        filter = filter.trim();
        if (filter && filters.indexOf(filter) < 0) filters.push(filter);
      });

      regionExploded.forEach(function (region) {
        region = region.trim();
        if (region && regions.indexOf(region) < 0) regions.push(region);
      });
    });

    var catList = document.querySelector(".people-filter-categories");
    var regList = document.querySelector(".people-filter-regions");

    if (catList) {
      filters.forEach(function (filter) {
        var li = document.createElement("li");
        li.textContent = filter;
        catList.appendChild(li);
      });
    }

    if (regList) {
      regions.forEach(function (region) {
        var li = document.createElement("li");
        li.textContent = region;
        regList.appendChild(li);
      });
    }

    document.body.addEventListener("click", function (e) {
      var li = e.target.closest("#people-filter li");
      if (!li) return;

      var activeLi = document.querySelector("#people-filter li.active");
      if (activeLi && activeLi !== li) activeLi.classList.remove("active");
      li.classList.toggle("active");

      var count = 0;

      document.querySelectorAll("[data-person]").forEach(function (person) {
        var matches = true;

        var regionActive = document.querySelector(".people-filter-regions li.active");
        var filterActive = document.querySelector(".people-filter-categories li.active");
        var regionText = regionActive ? regionActive.textContent : "";
        var filterText = filterActive ? filterActive.textContent : "";

        if (regionText && (person.dataset.region || "").indexOf(regionText) === -1) {
          matches = false;
        }

        if (filterText && (person.dataset.filter || "").indexOf(filterText) === -1) {
          matches = false;
        }

        if (matches) {
          count++;
          person.classList.remove("d-none");
        } else {
          person.classList.add("d-none");
        }
      });

      var emptyEl = document.querySelector("#empty");
      if (emptyEl) {
        emptyEl.style.display = count < 1 ? "" : "none";
      }

      AOS.refresh();
    });
  }

  // Login / recovery toggle
  document.body.addEventListener("click", function (e) {
    if (e.target.closest("a.recover")) {
      var loginEl = document.querySelector(".login");
      var recoveryEl = document.querySelector("div.recovery");
      if (loginEl) loginEl.style.display = "none";
      if (recoveryEl) recoveryEl.style.display = "";
    }
  });

  document.body.addEventListener("click", function (e) {
    if (e.target.closest(".show-login")) {
      var loginEl = document.querySelector(".login");
      var recoveryEl = document.querySelector("div.recovery");
      if (loginEl) loginEl.style.display = "";
      if (recoveryEl) recoveryEl.style.display = "none";
    }
  });

  // Announcement bar rotation
  var announcementInterval = setInterval(function () {
    if (document.querySelector(".announcement-bar__next")) {
      nextAnnouncement();
    }
  }, 6000);

  var nextAnnouncement = function () {
    var current = document.querySelector(".announcement-bar__message:not(.hidden)");
    if (!current) return;
    var next = current.nextElementSibling;

    if (!next || !next.classList.contains("announcement-bar__message")) {
      next = document.querySelector(".announcement-bar__message");
    }

    if (next) next.classList.remove("hidden");
    current.classList.add("hidden");
  };

  document.body.addEventListener("click", function (e) {
    if (!e.target.closest(".announcement-bar__prev")) return;
    clearInterval(announcementInterval);
    e.preventDefault();

    var current = document.querySelector(".announcement-bar__message:not(.hidden)");
    if (!current) return;
    var prev = current.previousElementSibling;

    if (!prev || !prev.classList.contains("announcement-bar__message")) {
      var all = document.querySelectorAll(".announcement-bar__message");
      prev = all[all.length - 1];
    }

    if (prev) prev.classList.remove("hidden");
    current.classList.add("hidden");
  });

  document.body.addEventListener("click", function (e) {
    if (!e.target.closest(".announcement-bar__next")) return;
    clearInterval(announcementInterval);
    e.preventDefault();
    nextAnnouncement();
  });

  // Menu hover intent
  var menuLinks = document.querySelectorAll(".header__nav-mega .header__nav-secondary-link > a");

  menuLinks.forEach(function (link) {
    hoverintent(
      link,
      function () {
        document.querySelectorAll(".header__nav-mega .header__nav-secondary-link a.hover").forEach(function (a) {
          a.classList.remove("hover");
        });

        document.querySelectorAll(".header__nav-promo").forEach(function (promo) {
          promo.style.display = "none";
        });

        var url = this.getAttribute("href");
        var showPromo = false;

        document.querySelectorAll(".header__nav-promo").forEach(function (promo) {
          if (!showPromo && promo.dataset.collectionHandle == url) {
            promo.style.display = "";
            showPromo = true;
          } else {
            promo.style.display = "none";
          }
        });

        this.classList.add("hover");
      },
      function () {}
    );
  });

  // Card information click
  document.querySelectorAll(".card-information").forEach(function (card) {
    card.addEventListener("click", function (e) {
      if (e.target.closest("quick-add-to-cart, .product-card__quick-add-form, quantity-input, .quantity")) return;
      if (
        !e.target.getAttribute("href") &&
        !e.target.classList.contains("card__link")
      ) {
        var link = card.querySelector(".card__link");
        if (link) link.click();
      }
    });
  });

  // Mobile facets toggle
  document.body.addEventListener("click", function (e) {
    if (!e.target.closest(".mobile-toggle-facets") && !e.target.closest(".facets-mobile-close")) return;
    e.preventDefault();

    if (body.classList.contains("facets--open")) {
      var formEl = document.querySelector("#FacetFiltersForm");
      if (formEl) formEl.classList.remove("in");
      setTimeout(function () {
        body.classList.remove("facets--open");
      });
      return;
    }

    body.classList.add("facets--open");

    var overlay = document.querySelector(".facets-overlay");
    if (!overlay) return;

    if (!overlay.querySelector("form")) {
      var formEl = document.querySelector("#FacetFiltersForm");
      if (formEl) {
        formEl.remove();
        overlay.appendChild(formEl);
        setTimeout(function () {
          formEl.classList.add("in");
        }, 100);
      }
    } else {
      var existingForm = overlay.querySelector("form");
      if (existingForm) existingForm.classList.add("in");
    }
  });

  // Facet category auto-open
  var facetCategory = document.querySelector(".facet--category");
  if (facetCategory) {
    if (facetCategory.querySelector(".list-menu__item--active")) {
      var summary = facetCategory.querySelector("summary");
      if (summary) summary.click();
    }
  }

  // Show all search
  document.body.addEventListener("click", function (e) {
    var showAll = e.target.closest(".show-all");
    if (!showAll) return;
    e.preventDefault();
    var form = showAll.closest("form.search");
    if (form) form.submit();
  });

  // Start chat
  document.body.addEventListener("click", function (e) {
    if (!e.target.closest(".start-chat") && !e.target.closest("a[href*=start-chat]")) return;
    e.preventDefault();
    zE(function () {
      zE.activate();
    });
  });

  // Timeline media modal
  document.body.addEventListener("click", function (e) {
    var tmedia = e.target.closest(".timeline-media");
    if (!tmedia) return;
    e.preventDefault();

    if (tmedia.closest(".timeline-modal")) return;
    if (e.target.classList.contains("close")) return;

    body.classList.add("showing-timeline-modal");

    var modal = tmedia.cloneNode(true);
    modal.classList.add("timeline-modal");
    var closeLink = document.createElement("a");
    closeLink.href = "#";
    closeLink.className = "close";
    closeLink.textContent = "Close";
    modal.appendChild(closeLink);
    body.appendChild(modal);
  });

  document.body.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      body.classList.remove("showing-timeline-modal");
      var modal = document.querySelector(".timeline-modal");
      if (modal) modal.remove();
    }
  });

  document.body.addEventListener("click", function (e) {
    if (!e.target.closest(".timeline-modal a")) return;
    e.preventDefault();
    body.classList.remove("showing-timeline-modal");
    var modal = document.querySelector(".timeline-modal");
    if (modal) modal.remove();
  });

  // Pagination load more
  document.body.addEventListener("click", function (e) {
    var btn = e.target.closest(".pagination__more");
    if (!btn) return;
    e.preventDefault();

    var container = document.querySelector("[data-pagination-container]");
    if (!container) return;

    btn.classList.add("loading");

    fetch(btn.getAttribute("href"))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var newContainer = doc.querySelector("[data-pagination-container]");
        if (newContainer) {
          Array.from(newContainer.children).forEach(function (child) {
            container.appendChild(child.cloneNode(true));
          });
        }

        var more = doc.querySelector(".pagination__more");
        var wrapper = btn.closest(".pagination-wrapper");
        var countEl = wrapper && wrapper.querySelector(".pagination-count");
        if (countEl && wrapper) {
          var total = parseInt(wrapper.dataset.paginationTotal, 10);
          var current = Math.min(container.children.length, total);
          var template = wrapper.dataset.viewingTemplate;
          if (template) {
            countEl.textContent = template
              .replace("__CURRENT__", current)
              .replace("__TOTAL__", total);
          }
        }

        swymCallbackFn();

        if (!btn.dataset.autoClick) {
          setQueryStringParameter("pagination__more", container.children.length);
        }

        if (window.CollectionPageCache) {
          window.CollectionPageCache.save();
        }

        if (more) {
          btn.classList.remove("loading");
          btn.setAttribute("href", more.getAttribute("href"));

          var page = getQueryStringParameter("pagination__more");
          if (page) {
            var pCount = parseInt(page, 10);
            var items = container.children.length;
            if (pCount > items) {
              btn.dataset.autoClick = "true";
              btn.click();
            } else {
              btn.dataset.autoClick = "";
              finishPaginationRestore();
            }
          }
        } else {
          btn.style.display = "none";
          btn.remove();
          finishPaginationRestore();
        }
      });
  });

  // Pagination link tracking — save cache + scroll target before leaving for product
  document.body.addEventListener(
    "click",
    function (e) {
      var link = e.target.closest("[data-pagination-container] a.card__link");
      if (!link) return;
      var product = link.closest(".product-card");
      if (!product) return;

      if (window.CollectionPageCache) {
        window.CollectionPageCache.save();
      }
      saveCollectionRestoreState(product);
    },
    true
  );

  window.addEventListener("pageshow", function (event) {
    if (event.persisted) {
      scrollToSelectedProduct();
    }
  });

  // Auto-load pagination (skip when collection cache already restored the grid)
  if (!window.__collectionPageCacheRestored) {
    var paginationMore = document.querySelector(".pagination__more");
    if (paginationMore) {
      var page = getQueryStringParameter("pagination__more");
      if (page) {
        var pCount = parseInt(page, 10);
        var container = document.querySelector("[data-pagination-container]");
        if (shouldAutoRestorePagination(container, pCount)) {
          paginationMore.dataset.autoClick = "true";
          paginationMore.click();
        } else if (container && container.children.length >= pCount) {
          finishPaginationRestore();
        }
      }
    }
  } else {
    finishPaginationRestore();
  }

  // Card inner media click
  document.body.addEventListener("click", function (e) {
    var media = e.target.closest(".card__inner .media");
    if (!media) return;
    if (e.target.closest("quick-add-to-cart, .product-card__quick-add-form, quantity-input, .quantity")) return;
    if (
      !e.target.getAttribute("href") &&
      !e.target.classList.contains("waitlist-action")
    ) {
      var card = media.closest(".card__inner");
      if (!card) return;
      var link = card.querySelector(".card__link");
      if (link) {
        if (window.CollectionPageCache) {
          window.CollectionPageCache.save();
        }
        var product = card.closest(".product-card");
        if (product) saveCollectionRestoreState(product);
        window.location.href = link.getAttribute("href");
      }
    }
  });

  // Product cross sell carousel
  var crossSellEl = document.querySelector("#product-cross-sell-carousel");
  if (crossSellEl) {
    var maxCrossSell = crossSellEl.querySelectorAll("li").length;
    var crossSell = new Glide("#product-cross-sell-carousel", {
      type: "slider",
      perView: maxCrossSell < 3 ? maxCrossSell : 3,
      rewind: false,
      startAt: 0,
      breakpoints: {
        1132: { perView: maxCrossSell < 2 ? maxCrossSell : 2 },
        1024: { perView: maxCrossSell < 2 ? maxCrossSell : 2 },
      },
    });
    fixIosControls(crossSell);
    crossSell.mount();
  }

  /* handle wishlists */
  var wishlistButton = document.querySelectorAll(".waitlist-action");

  function swymCallbackFn() {
    if (wishlistButton.length > 0) {
      _swat.fetch(fetchCallbackFn);
    }
  }

  function fetchCallbackFn(products) {
    document.querySelectorAll(".waitlist-action").forEach(function (btn) {
      var activeProductId = btn.getAttribute("data-empi");

      var isInWishlist = products.find(function (p) {
        return p.empi == activeProductId;
      });

      if (isInWishlist) {
        btn.classList.add("added");
      } else {
        btn.classList.remove("added");
      }

      btn.addEventListener("click", function (e) {
        var request =
          window.WishListData[parseInt(e.target.getAttribute("data-empi"))];

        if (e.target.classList.contains("added")) {
          _swat.removeFromWishList(request, function () {
            btn.classList.remove("added");
          });
        } else {
          _swat.addToWishList(request, function () {
            btn.classList.add("added");
          });
        }
      });
    });
  }

  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }

  window.fetchCallbackFn = fetchCallbackFn;
  window.SwymCallbacks.push(swymCallbackFn);

  // Merge people feeds
  var peopleFeeds = document.querySelectorAll(".people-feed");
  if (peopleFeeds.length > 1) {
    var first = null;
    peopleFeeds.forEach(function (elem, i) {
      if (i === 0) {
        first = elem;
        return;
      }
      var persons = elem.querySelectorAll("[data-person]");
      persons.forEach(function (person) {
        first.appendChild(person);
      });
      elem.remove();
    });
  }

  // Agree terms checkbox
  var agreeTerms = document.querySelector("#agree-terms");
  if (agreeTerms) {
    if (getCookie("terms") === "true") {
      agreeTerms.checked = true;
    }

    var agreeTermsCheck = function () {
      var targets = document.querySelectorAll(".agree-terms-target");
      if (agreeTerms.checked) {
        targets.forEach(function (t) { t.classList.remove("agree-terms-target--disabled"); });
        setCookie("terms", true, 365);
      } else {
        targets.forEach(function (t) { t.classList.add("agree-terms-target--disabled"); });
        setCookie("terms", false, 365);
      }
    };

    agreeTerms.addEventListener("change", function () {
      agreeTermsCheck();
    });

    agreeTermsCheck();
  }

  // Cross sell hide if empty
  var crossSellSection = document.querySelector(".cross-sell");
  if (crossSellSection) {
    if (!crossSellSection.querySelector(".cross-sell .glide__slide")) {
      crossSellSection.style.display = "none";
    }
  }

  // Facets "all" checkbox logic
  document.body.addEventListener("change", function (e) {
    if (e.target.closest(".facets__all") && e.target.tagName === "INPUT") {
      if (e.target.checked) {
        var list = e.target.closest(".facets__list");
        if (list) {
          list.querySelectorAll("li:not(.facets__all) input").forEach(function (inp) {
            inp.checked = false;
          });
        }
      }
    }
  });

  document.body.addEventListener("change", function (e) {
    var li = e.target.closest(".facets__list li:not(.facets__all)");
    if (li && e.target.tagName === "INPUT") {
      var list = e.target.closest(".facets__list");
      if (list) {
        var allInput = list.querySelector(".facets__all input");
        if (allInput) allInput.checked = false;
      }
    }
  });

  // Custom select init (replaces Select2)
  CustomSelect.init();

  // Listen for native change events on selects to dispatch custom events
  document.body.addEventListener("change", function (e) {
    if (e.target.tagName === "SELECT") {
      if (e.target.matches("[id*=Option-]")) {
        document.body.dispatchEvent(new Event("variantchange"));
      }
      if (e.target.name === "sort_by") {
        document.body.dispatchEvent(new Event("sortchange"));
      }
    }
  });

  // Carouselable wrapper arrows
  document.querySelectorAll("[data-carouselable-wrapper] .glide__arrow").forEach(function (arrow) {
    arrow.addEventListener("click", function (e) {
      e.preventDefault();

      var carousel = arrow.closest("[data-carouselable-wrapper]");
      if (!carousel) return;

      var selected = carousel.querySelector("[data-carouselable]:not(.mobile-slide--hidden)");
      if (!selected) return;

      var next = selected.nextElementSibling;
      while (next && !next.hasAttribute("data-carouselable")) next = next.nextElementSibling;

      var prev = selected.previousElementSibling;
      while (prev && !prev.hasAttribute("data-carouselable")) prev = prev.previousElementSibling;

      if (!prev) {
        var all = carousel.querySelectorAll("[data-carouselable]");
        prev = all[all.length - 1];
      }

      if (!next) {
        next = carousel.querySelector("[data-carouselable]");
      }

      selected.classList.add("mobile-slide--hidden");

      if (arrow.classList.contains("glide__arrow--right")) {
        if (next) next.classList.remove("mobile-slide--hidden");
      } else {
        if (prev) prev.classList.remove("mobile-slide--hidden");
      }
    });
  });

  AOS.init();

  function resizeActions() {
    var bannerParagraphs = document.querySelectorAll(".banner--has-mobile-version p");
    var bannerSecondary = document.querySelectorAll(".banner-secondary-text");

    if (bannerParagraphs.length > 1) {
      bannerSecondary.forEach(function (el) {
        if (BREAK_MD < window.innerWidth) {
          el.classList.remove("remain");
        } else {
          el.classList.add("remain");
        }
      });
    } else {
      bannerSecondary.forEach(function (el) {
        el.classList.remove("remain");
      });
    }
  }

  document.querySelectorAll(".banner-metadata").forEach(function (elem) {
    elem.innerHTML = elem.innerHTML.replaceAll(
      "|",
      '<span class="banner-metadata-separator">|</span>'
    );
  });

  resizeActions();

  window.addEventListener("resize", resizeActions);

  body.classList.add("loaded");
  body.dispatchEvent(new Event("start:animation"));
});
